(function () {
    'use strict';

    /**
     * Featured links section - owns its data and loading.
     * Used as an attribute on the server rendered <section> (Views/Events/_FeaturedLinks.cshtml).
     * No template and a child scope, so the Razor markup inside binds to "featuredLinksSection"
     * and still sees the page "vm" (getStyle, showLoading).
     */
    angular
        .module('EventListApp')
        .directive('wsSectionFeaturedLinks', sectionFeaturedLinks);

    function sectionFeaturedLinks() {
        return {
            restrict: 'A',
            scope: true,
            controller: SectionFeaturedLinksCtrl,
            controllerAs: 'featuredLinksSection'
        };
    }

    SectionFeaturedLinksCtrl.$inject = ['$element', 'ApiFactory', 'SectionRegistry'];

    function SectionFeaturedLinksCtrl($element, ApiFactory, SectionRegistry) {
        const vm = this;
        vm.items = [];

        vm.$onInit = function () {
            SectionRegistry.register($element[0].id, load);
        };

        /**
         * Load the featured links of the event
         * @param {number} eventId
         * @param {number} lang
         * @returns {Promise}
         */
        function load(eventId, lang) {
            return ApiFactory.GetFeaturedLinks(eventId, lang).then(function (response) {
                vm.items = response.data;
            });
        }
    }
})();
